import {
  NgbDateParserFormatter,
  NgbDateStruct
} from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct | null {
    if (value) {
      const dateParts = value.trim().split('/');
      if (dateParts.length === 3) {
        return {
          month: +dateParts[0],
          day: +dateParts[1],
          year: +dateParts[2]
        };
      }
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    return date
      ? `${this.padNumber(date.month)}/${this.padNumber(date.day)}/${date.year}`
      : '';
  }

  private padNumber(n: number): string {
    return n < 10 ? '0' + n : n.toString();
  }
}
